import { ResponsePostAuthLogin } from "./login";

export const RouteGetAuthUser = "/auth/user";

export type ResponseGetAuthUser = ResponsePostAuthLogin["user"];
